import React from "react";
import { Table } from "react-bootstrap";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { useGetAllQuery } from "../../redux/onco/onco";

const columns = [
  {
    title: "No",
  },
  {
    title: "ID",
  },
  {
    title: "Familiya",
  },
  {
    title: "Ism",
  },
  {
    title: "Telefon raqami",
  },
  {
    title: "Bo`lim",
  },
  {
    title: "Xona",
  },
  {
    title: "Muammo",
  },
  {
    title: "Sana",
  },
  {
    title: "Vaqti",
  },
  {
    title: "Status",
  },
  {
    title: "Qilingan ish",
  },
  {
    title: "Xodim",
  },
];

const Onco = () => {
  const { data } = useGetAllQuery();

  return (
    <>
      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success mb-3"
        table="table-to-xls"
        filename="Onco"
        sheet="Onco"
        buttonText="Export to Excel"
      />
      <Table hidden id="table-to-xls" striped bordered hover>
        <thead>
          <tr>
            {columns?.map((item, index) => (
              <th key={index}>{item.title}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.list?.map((item, index) => (
            <tr key={item.id}>
              <td>{index + 1}</td>
              <td>{item?.code}</td>
              <td>{item?.surname}</td>
              <td>{item?.name}</td>
              <td>{item?.phoneNumber}</td>
              <td>{item?.department}</td>
              <td>{item?.roomNumber}</td>
              <td>{item?.problem}</td>
              <td>{item?.createdAt?.slice(0, 10)}</td>
              <td>{item?.createdAt?.slice(11, 16)}</td>
              <td className={item.finished === true ? "gr" : "red"}>
                {item?.finished === true ? <span>1</span> : <span>0</span>}
              </td>
              <td>{item?.doneWork}</td>
              <td width={110}>{item?.updatedBy?.fullName}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};
export default Onco;
